import { getIsUnplannedReactiveScope } from 'pages/WellGuardian/WIR/utils';
import { CountryData, WIR } from 'types/wellGuardian';

const INTERVENTION_COMPLETE_INDEX = 7;

const INTERVENTION_COMPLETE_INDEX_DK = 5;

const INTERVENTION_COMPLETE_INDEX_REACTIVE_SCOPE = 3;

export const getInterventionCompleteIndex = (wir: WIR | null, country: string) => {
  if (country === CountryData.denmark) {
    return getIsUnplannedReactiveScope(wir)
      ? INTERVENTION_COMPLETE_INDEX_REACTIVE_SCOPE
      : INTERVENTION_COMPLETE_INDEX_DK;
  } else {
    return getIsUnplannedReactiveScope(wir)
      ? INTERVENTION_COMPLETE_INDEX_REACTIVE_SCOPE
      : INTERVENTION_COMPLETE_INDEX;
  }
};

export const getInterventionCompleteIndexDk = (wir: WIR | null) => {
  return getIsUnplannedReactiveScope(wir)
    ? INTERVENTION_COMPLETE_INDEX_REACTIVE_SCOPE
    : INTERVENTION_COMPLETE_INDEX_DK;
};
